import * as React from "react";

function ChevronLeft(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.343 8l4.324 4.467-.839.866L4.667 8l5.161-5.333.839.866L6.343 8z"
      />
    </svg>
  );
}

export default ChevronLeft;
